module.exports = __webpack_public_path__ + "static/SpecialMembers-146350d16419a7fecabf8cecfabda9df.png";